export default __webpack_public_path__ + "static/media/gaelle.9f5b0897.jpeg";